export default {
    race_10000: 'All',
    race_1: 'All Population',
    race_2: 'Hispanic, Any race',
    race_3: 'Non-Hispanic, Other races',
    race_4: 'Non-Hispanic, Black',
    race_5: 'Non-Hispanic, White',
    race_6: 'Non-Hispanic, American Indian or Alaskan Native',
    race_7: 'Non-Hispanic, Asian or Pacific Islander',
    race_8: 'Non-Hispanic, Native Hawaiian and Other Pacific Islander',
    race_9: 'Non-Hispanic, Asian',
    race_10: 'Non-Hispanic, White alone',
    race_11: 'Non-Hispanic, Black alone',
    race_12: 'Non-Hispanic, American Indian, Alaskan Native alone',
    race_13: 'Non-Hispanic, Asian alone',
    race_14: 'Non-Hispanic, Native Hawaiian and Other Pacific Islander alone',
    race_15: 'Non-Hispanic, Multiracial',
    race_17: 'Non-Hispanic, neither Black alone nor White alone',
    race_18: 'Not Hispanic, Any Race',
    race_24: 'Black (both Hispanic and non-Hispanic)',
    race_25: 'White (both Hispanic and non-Hispanic)',
    race_26: 'American Indian or Alaskan Native (both Hispanic and non-Hispanic)',
    race_27: 'Asian or Pacific Islander (both Hispanic and non-Hispanic)',
    race_28: 'Native Hawaiian or Other Pacific Islander (both Hispanic and non-Hispanic)',
    race_29: 'Asian (both Hispanic and non-Hispanic)',
    race_30: 'White alone (both Hispanic and non-Hispanic)',
    race_31: 'Black alone (both Hispanic and non-Hispanic)',
    race_32: 'American Indian or Alaskan Native alone (both Hispanic and non-Hispanic)',
    race_33: 'Asian alone (both Hispanic and non-Hispanic)',
    race_34: 'Native Hawaiian or Other Pacific Islander alone (both Hispanic and non-Hispanic)',
    race_35: 'Two or More Races (both Hispanic and non-Hispanic)',
    race_36: 'Neither Black alone nor White alone (both Hispanic and non-Hispanic)',
    race_37: 'Non-Hispanic, neither Black nor White',
    race_38: 'Neither Black nor White (both Hispanic and non-Hispanic)',
    race_39: 'Some Other Race (both Hispanic and non-Hispanic)',
    race_40: 'Unknown Race (both Hispanic and non-Hispanic)',
};
